import { render } from "./TeamMembers.vue?vue&type=template&id=49ad9a67&ts=true"
import script from "./TeamMembers.vue?vue&type=script&lang=ts"
export * from "./TeamMembers.vue?vue&type=script&lang=ts"

import "./TeamMembers.vue?vue&type=style&index=0&id=49ad9a67&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_typescript@5.9.3__webpack@5.107.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__